<template>
    <article class="article-wrapper article2">
        <audio :src="data.audio_path" type="audio/mpeg"
        ref="instructorMusic" preload></audio>
        <audio src="@/assets/audio/section2_h.mp3" type="audio/mpeg"
        ref="hoverMusic" preload></audio>
        <div class="line-wrapper fade7"
        :class="{'active': $parent.isfadeInActive && $parent.isfadeInA2,
        'line-bg1':targetIdx===0,
        'line-bg2':targetIdx===1,
        'line-bg3':targetIdx===2}">
            <div id="article2Photo" class="photo-wrapper cursor-pointer fade7"
            :class="{'active': $parent.isfadeInActive && $parent.isfadeInA2}"
            v-on:click.prevent="play();gaEvent('play_btn', 'announce_play');">
                <div v-if="data.images && data.images.length">
                    <div class="photos"
                    v-on:mouseenter="toggleHoverMusic(true)"
                    v-on:mouseleave="toggleHoverMusic(false)">
                        <img :src="data.images[0]"
                        class="photo" v-show="!talkToggle"/>
                        <img :src="data.images[1]"
                        class="photo" v-show="talkToggle"/>
                    </div>
                    <span class="report-btn" title="點擊圖片聽報告">
                    </span>
                </div>
            </div>
            <div class="text-wrapper">
                <h1 class="title fade7" v-html="formatTitle(data.title)"
                :class="{'active': $parent.isfadeInActive && $parent.isfadeInA2}">防堵疫情，人人有責</h1>
                <div class="info-wrapper fade8"
                :class="{'active': $parent.isfadeInActive && $parent.isfadeInA2}">
                    <p class="source">
                        【發布單位／{{data.title_unit}}】
                        <a href="" title="FB分享" class="fb-btn"
                        @click.prevent="$parent.onShare('fb', data.share_link);
                        gaEvent('share_fb', 'announce_sharefb');">
                            <img src="@/assets/images/btn_article_fb_n@3x.png" />
                        </a>
                        <a href="" title="Line分享" class="line-btn"
                        @click.prevent="$parent.onShare('line',
                        data.share_link_line, data.line_text);
                        gaEvent('share_line', 'announce_shareline');">
                            <img src="@/assets/images/btn_article_line_n@3x.png" />
                        </a>
                    </p>
                </div>
                <p id="article2Description" class="description fade9"
                :class="{'active': $parent.isfadeInActive && $parent.isfadeInA2}"
                v-html="data.content">
                    <span>
                        鑒於近期全球疫情鋪天蓋地而來，教官室秉持國家有難，匹夫有責的精神，
                        勸勉各位同學勤洗手、戴口罩，若有發燒、咳嗽、失去嗅覺味覺等相關症狀，請立即通報1922防疫專線，會有專人給予適當協助。
                    </span>
                    <span>
                        本校還接獲通知近期有同學居家檢疫出外趴趴走。請同學協助舉報可疑人士，若隱匿有可能的逃「疫」者，與疫者同罪，國家會感謝你的。
                    </span>
                </p>
            </div>
        </div>
    </article>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'broadcast2',
    props: {
        data: {
            type: Object,
            default() {
                return {
                    title: '',
                    title_unit: '',
                    content: '',
                    image_path: '',
                    audio_path: '',
                    share_link: '',
                };
            },
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            gaCategory: '',
            // 是否正在播放
            isPlay: false,
            talkToggle: false,
            // 延遲毫秒
            delayMs: 0, // 3600,
        };
    },
    mounted() {
    },
    methods: {
        play() {
            this.isPlay = !this.isPlay;
            if (!this.isPlay) {
                this.stop();
                return;
            }

            this.$parent.cancelOtherMusic('instructorMusic');
            if (this.targetIdx === 1) {
                this.$parent.cancelOtherMusic('tvVideo');
            }
            this.playAudio('hoverMusic', true);

            this.playAudio('instructorMusic', false, () => {
                window.clearInterval(window.talking);
                this.isPlay = false;
                this.talkToggle = false;
                this.$parent.volBgMusic(1);
            });

            window.delayTalk = window.setTimeout(() => {
                window.talking = window.setInterval(() => {
                    this.talkToggle = !this.talkToggle;
                }, 400);
            }, this.delayMs);
        },
        stop() {
            if (window.talking) window.clearInterval(window.talking);
            if (window.delayTalk) window.clearTimeout(window.delayTalk);
            this.playAudio('instructorMusic', true);
            this.$parent.volBgMusic(1);
            this.talkToggle = false;
        },
        toggleHoverMusic(isPlay) {
            if (this.isPlay) {
                return;
            }
            this.talkToggle = isPlay;
            this.playAudio('hoverMusic', !isPlay);
        },
    },
    mixins: [mixinMethod],
};
</script>
